import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { getData } from "Source/globalFunction";

import Select from "Components/common/Select/Select";
import Avatar from "Components/common/Avatar/Avatar";

@connect(store => {
    return {
        workstreams: store.workstreams
    };
})

class Search extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            searchIsLoading: false,
            searched: []
        }
    }

    render() {
        const { workstreams, projectId } = this.props;

        const searchMembers = value => {
            const url = `/api/projects/${projectId}/members`;
            let params = {};
            if (value) {
                params.memberName = value;
            }
            this.setState({ ...this.state, searchIsLoading: true });
            getData(url, { params }, response => {
                if (response) {
                    this.setState({
                        ...this.state,
                        searchIsLoading: false,
                        searched: response.data.filter(m => {
                            const user = m.user || {};
                            return workstreams.selected.members.filter(s => s.assign === "responsible").map(s => s.id).indexOf(user.id) === -1;
                        }).map(m => {
                            const user = m.user || {};
                            return {
                                value: user.id,
                                label: `${user.firstName} ${user.lastName}`,
                                others: {
                                    id: user.id,
                                    fullName: `${user.firstName} ${user.lastName}`,
                                    role: m.role || '',
                                    avatar: user.avatar
                                }
                            };
                        })
                    });
                }
            });
        }

        const handleOpenSelect = () => {
            searchMembers();
        }

        const handleSearchMembers = (value) => {
            searchMembers(value);
        }

        const handleSelectMember = (value) => {
            this.props.onChange(value);
        }

        return (
            <Select 
                showSelectedInOptions={false}
                isSearchable={true}
                isClose={this.props.isClose}
                isLoading={this.state.searchIsLoading}
                placeholder="Select"
                classes={{options: "reassignLeadInput"}}
                options={this.state.searched}
                renderOption={option => (
                    <div class="memberOption">
                        <div class="memberMainDetails">
                            <Avatar name={option.label} disableTooltip={true} image={option.others.avatar !== "default.png" ? `${this.props.avatarBaseUrl}${option.others.avatar}` : null} />
                            <span>{option.label}</span>
                        </div>
                        <div class="memberRole">
                            <span>{option.others.role}</span>
                        </div>
                    </div>
                )} 
                renderSelected={option => (
                    <div class="memberOption">
                        <div class="memberMainDetails">
                            <Avatar name={option.label} disableTooltip={true} image={option.others.avatar !== "default.png" ? `${this.props.avatarBaseUrl}${option.others.avatar}` : null} />
                            <span>{option.label}</span>
                        </div>
                    </div>
                )}
                onOpen={handleOpenSelect}
                onSearch={handleSearchMembers}
                onChange={handleSelectMember}
            />
        );
    }
}

export default Search;
